import ConnectionService, { HttpMethod } from './connection.service';
import { StatDeviceSum, StatNumber, StatDateNumbers, DailyStats } from '../../models/stat.model';

class StatsConnection {
  public async getAppVersions(data: object): Promise<string[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/stats/appVersions`, HttpMethod.GET, data);
  }

  public async getAverages(data: object): Promise<StatNumber> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/stats/averages`, HttpMethod.GET, data);
  }

  public async getLogSums(data: object): Promise<StatDateNumbers[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/stats/logSums`, HttpMethod.GET, data);
  }

  public async getDeviceCount(data: object): Promise<{exception: number, error: number, warning:number, device: number}> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/stats/deviceCount`, HttpMethod.GET, data);
  }

  public async getSumHistogram(data: object): Promise<{time: Date, count: number}[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/stats/sumHistogram`, HttpMethod.GET, data);
  }
  
  public async getDeviceSums(data: object): Promise<StatDeviceSum[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/stats/deviceSums`, HttpMethod.GET, data);
  }

  public async getAffectedDevices(data: object): Promise<StatDateNumbers[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/stats/effectedDevices`, HttpMethod.GET, data);
  }

  public async getDailyStats(data: object): Promise<DailyStats> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/stats/dailyStats`, HttpMethod.GET, data);
  }
}

export default new StatsConnection();